import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle
} from '@mui/material';
import { FormProvider, useForm } from 'react-hook-form';
import { useCartState } from 'supplier-portals/uxbeauty/contexts/cart/CartContext';
import { AddToCartForm } from './helpers/AddToCartForm';
import { CartItem } from 'supplier-portals/uxbeauty/contexts/cart/types';
import { FormState } from './AddToCartDialog';
import piwik from 'piwik/piwik';

interface EditCartDialogProps {
  open: boolean;
  onClose: () => void;
  product: CartItem;
}

export const EditCartDialog = ({
  open,
  onClose,
  product
}: EditCartDialogProps) => {
  const methods = useForm<FormState>({
    defaultValues: {
      neededBy: product.neededBy,
      estimatedYearlyUsage: product.estimatedYearlyUsage,
      quantity: product.quantity
    }
  });
  const { handleSubmit } = methods;
  const { setValue } = useCartState();

  const updateItem = (data: FormState) => {
    setValue(prev => {
      const updatedItems = prev.items.map(item =>
        item.old_key === product.old_key ? { ...item, ...data } : item
      );
      return { ...prev, items: updatedItems };
    });
    piwik.push(['trackEvent', 'UXB cart', 'edited product']);
    onClose();
  };
  return (
    <FormProvider {...methods}>
      <Dialog open={open} onClose={onClose} maxWidth="xs">
        <DialogTitle>Edit Sample</DialogTitle>
        <form onSubmit={handleSubmit(updateItem)}>
          <DialogContent>
            <AddToCartForm />
          </DialogContent>
          <DialogActions>
            <Button variant="text" onClick={() => onClose()}>
              Cancel
            </Button>
            <Button variant="contained" type="submit">
              Add to cart
            </Button>
          </DialogActions>
        </form>
      </Dialog>
    </FormProvider>
  );
};
